import { useTranslations } from "next-intl";

import {
  Img,
  Tag,
  Tooltip,
  TooltipFocusableTrigger,
} from "@zapier/design-system";

import { useSize } from "@zapier/reporting/src/hooks/useSize";
import { getTooltipPosition, pillOverride } from "../indicatorStyles";

function PathIndicator() {
  const t = useTranslations("run-log.path-indicator");
  const size = useSize();

  return (
    <Tooltip content={t("tooltip")} placement={getTooltipPosition(size)}>
      <TooltipFocusableTrigger>
        <div css={pillOverride} data-testid="path-indicator">
          <Tag variant="Red2" size="x-small">
            <Img
              alt={t("image-alt")}
              borderRadius="none"
              height={16}
              src="https://zapier.com/generated/BranchingAPI/64"
              width={16}
            />
          </Tag>
        </div>
      </TooltipFocusableTrigger>
    </Tooltip>
  );
}

export default PathIndicator;
